import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import Icon from 'components/Icon'
import ListRow from 'components/ListRow'

class NotificationImage extends React.Component {
  static defaultProps = {
    source: null,
    icon: null,
    iconColor: null
  }

  static propTypes = {
    source: PropTypes.string,
    url: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconColor: PropTypes.string
  }

  render () {
    if (this.props.icon) {
      return (
        <Link to={this.props.url}>
          <ListRow.Image>
            <Icon
              icon={this.props.icon}
              size={Icon.SIZE.MEDIUM}
              color={this.props.iconColor}
            />
          </ListRow.Image>
        </Link>
      )
    }
    return (
      <Link to={this.props.url}>
        <ListRow.Image source={this.props.source} />
      </Link>
    )
  }
}

export default NotificationImage
